import NotifyAlertComponent from '@components/notifyAlert/NotifyAlertComponent';
import { LocalStorageKeys } from '@containers/App';
import Unit from '@interfaces/IUnit';
import AppContext from '@services/Context';
import I18n from '@src/i18n';
import { Dropdown, Icon as IconAnt, Menu } from 'antd';
import React, { Component } from 'react';

import styled from '../styled-components';
import FormBuilder, { FormSettingsType } from './Form';
import Icon from './Icon';

let items = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Espanõl' },
  { value: 'pt-BR', label: 'Português' },
]

export default class PageHeader extends Component<any, any> {
  private currentPillar: string;
  constructor(props: any) {
    super(props);
    this.currentPillar = String(localStorage.getItem(LocalStorageKeys.PILLAR))
  }

  UNSAFE_componentWillMount = async () => {
    if (this.currentPillar === 'LI') {
      items = [
        { value: 'en', label: 'English' },
        { value: 'pt-BR', label: 'Português' },
      ]
    }
  }

  render() {
    return (
      <AppContext.Consumer>
        {({ theme, locale, ChangeLocale, ChangePillar, ChangeUnit, Logout, client, user, activeUnitId, units, iot, pillar, updateNotificationVar }) => (
          <Wrapper theme={theme}>
            <LogoContainer theme={theme}>
              <Logo src={client.logo} alt="" />
            </LogoContainer>
            <Nav>

              <PillarsSelect>
                <Dropdown overlay={this.getPillarsMenu(client.pillars, ChangePillar)} trigger={['click']}>
                  <a className="pillars-dropdow" href="#">
                    <IconAnt type="appstore" />
                  </a>
                </Dropdown>

              </PillarsSelect>

              {pillar !== "LI" && !!activeUnitId && (
                <NotifyAlertComponent
                  key={updateNotificationVar}
                  activeUnitId={activeUnitId}
                  activePillarId={pillar}
                  iot={iot}
                  user={user}
                  shouldUpdateNotifications={this.props.shouldUpdateNotifications}
                  updateNotificationVar={updateNotificationVar}
                  updateNotifyContent={this.props.updateNotifyContent} />
              )}

              <FormBuilder
                settings={this.getChangeLocaleForm(locale)}
                onSubmit={(values: { locale: string }) =>
                  values.locale ? ChangeLocale(values.locale) : null
                }
              />

              <UserName>
                <Icon name="user" />
                <span>{user && user.name}</span>
              </UserName>

              <LogoutButton onClick={Logout}>
                <Icon name="power-off" />
                {locale && I18n.l('common.logout')}
              </LogoutButton>

            </Nav>
          </Wrapper>
        )}
      </AppContext.Consumer>
    );
  }

  getChangeLocaleForm = (locale?: string): FormSettingsType => {
    return {
      submitOnFieldChange: true,
      fields: [
        {
          type: 'select',
          name: 'locale',
          optionLabel: 'label',
          optionValue: 'value',
          items: items,
          hideClearButton: true,
          initialValue: locale,
          addorn: {
            leftIcon: 'globe',
          },
        },
      ],
    }
  }

  getChangeUnitForm = (activeUnitId: string, units: Unit[]): FormSettingsType => {

    const _values: any = [];

    units.map((unit: Unit) => {
      _values.push({
        value: unit.id,
        label: unit.name
      });
    });

    return {
      submitOnFieldChange: true,
      fields: [
        {
          type: 'select',
          name: 'unit',
          optionLabel: 'label',
          optionValue: 'value',
          items: _values,
          hideClearButton: true,
          initialValue: activeUnitId,
        }
      ]
    }
  
  }

  getPillarsMenu = (pillars: any, ChangePillar: Function) => {
    const menu = (
      <Menu>
        {pillars.map((name: any, index: any) => {
          return (
            name !== 'RS' &&
            <Menu.Item key={index}>
              <a onClick={() => { ChangePillar(name) }}>{name}</a>
            </Menu.Item>
          )
        })}
      </Menu>
    );

    return menu;
  }
}
//#region CSS

const PillarsSelect = styled.div`
    a {
        color: #40464D !important
    }
    .pillars-dropdow {
        font-size: 28px;
        margin: 0 20px;        
    }
`;
const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background: ${({ theme }) => theme.background};
  box-shadow: ${({ theme }) => theme.boxShadow};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
  height: ${({ theme }) => theme.headerHeight || '120px'};
  width: 100%;
  padding-left: ${({ theme }) => theme.sidebarSize};
  z-index: 3;
  .form-select-wrapper{
    font-size: 15px;

    button {
        font-size: 15px;
    }
  }
`;

const LogoContainer = styled.div`
  flex: ${({ theme }) => `0 0 ${theme.sidebarSize}` || '150px'};
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 20px;
`;

const Logo = styled.img`
  margin-bottom: 0.5rem;
  max-width: 90%;
  max-height: 80px;  
`;

const Nav = styled.div`
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
  margin: 0 20px;

  .form-wrapper {
    width: auto;
  }
  .form-field-wrapper {
    margin-right: 0;
  }
  > * + * {
    margin-right: 1rem;
  }
`;

const LogoutButton = styled.div`
  cursor: pointer;
  font-size: 15px;
  text-transform: capitalize;
  text-align: right;
  margin: 0 15px;
  color: #40464D;

  .icon {
    margin-right: 5px;
  }
`;

const UserName = styled.div`
    margin: 0 15px;
    font-size: 15px;
  .icon {
    margin-right: 5px;
  }
`;

//#endregion